<div class="page-container">
  <div class="page-header" style="display: flex; justify-content: space-between; align-items: center">
    <div>
      <h2>Notifications</h2>
      <span class="header-count">{{ totalItems }} notifications</span>
    </div>
    <div class="header-actions">
      <button 
        class="btn-continue" 
        (click)="clearAll()" 
        *ngIf="notifications.length > 0"
        style="background: #ef4444; color: white; border: none; padding: 10px 24px; border-radius: 6px; font-weight: 600; cursor: pointer;">
        <i class="fa-solid fa-trash" style="margin-right: 8px"></i> Clear All
      </button>
    </div>
  </div>

  <div class="header-controls">
    <div class="search-box">
      <i class="fa-solid fa-magnifying-glass"></i>
      <input type="text" [value]="searchTerm" (input)="onSearchChange($event)" placeholder="Search notifications..." />
    </div>

    <!-- Filters Popover -->
    <div class="filter-wrapper">
      <button 
        class="btn-filter-settings" 
        (click)="showFilterPanel = !showFilterPanel"
        [class.filter-active]="statusFilter !== 'All' || typeFilter !== 'All' || dateFilter !== 'All'">
        <i class="fa-solid fa-sliders"></i> Filters
        <span class="filter-count" *ngIf="statusFilter !== 'All' || typeFilter !== 'All' || dateFilter !== 'All'">
          {{ (statusFilter !== 'All' ? 1 : 0) + (typeFilter !== 'All' ? 1 : 0) + (dateFilter !== 'All' ? 1 : 0) }}
        </span>
      </button>

      <!-- Filter Panel Dropdown -->
      <div class="filter-panel" *ngIf="showFilterPanel">
        <div class="filter-panel-header">
          <span class="filter-panel-title">
            <i class="fa-solid fa-sliders"></i> Filters
          </span>
          <button class="filter-clear-btn" (click)="clearAllFilters()">Clear all</button>
        </div>

        <!-- Status Section -->
        <div class="filter-section">
          <div class="filter-section-label">STATUS</div>
          <div class="filter-chips">
            <button class="filter-chip" [class.active]="statusFilter === 'All'" (click)="setStatusFilter('All')">All</button>
            <button class="filter-chip" [class.active]="statusFilter === 'Read'" (click)="setStatusFilter('Read')">Read</button>
            <button class="filter-chip" [class.active]="statusFilter === 'Unread'" (click)="setStatusFilter('Unread')">Unread</button>
          </div>
        </div>

        <!-- Type Section -->
        <div class="filter-section">
          <div class="filter-section-label">TYPE</div>
          <div class="filter-chips">
            <button class="filter-chip" [class.active]="typeFilter === 'All'" (click)="setTypeFilter('All')">All</button>
            <button class="filter-chip" *ngFor="let t of types" [class.active]="typeFilter === t" (click)="setTypeFilter(t)">
              {{ t | uppercase }}
            </button>
          </div>
        </div>

        <!-- Date Range Section -->
        <div class="filter-section">
          <div class="filter-section-label">DATE RANGE</div>
          <div class="filter-chips">
            <button class="filter-chip" [class.active]="dateFilter === 'All'" (click)="setDateFilter('All')">All</button>
            <button class="filter-chip" *ngFor="let d of dateRanges" [class.active]="dateFilter === d" (click)="setDateFilter(d)">
              {{ d }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="table-container">
    <table mat-table [dataSource]="filteredNotifications" class="mat-elevation-z0 booking-table">
      
      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>STATUS</th>
        <td mat-cell *matCellDef="let n">
          <span class="status-chip" [ngClass]="n.isRead ? 'completed' : 'pending'">
            {{ n.isRead ? 'READ' : 'UNREAD' }}
          </span>
        </td>
      </ng-container>

      <!-- Type Column -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>TYPE</th>
        <td mat-cell *matCellDef="let n">
          <span class="type-icon-container" [ngClass]="n.type">
            <i class="fa-solid" [ngClass]="{
              'fa-circle-info': n.type === 'info',
              'fa-circle-check': n.type === 'success',
              'fa-triangle-exclamation': n.type === 'warning',
              'fa-circle-xmark': n.type === 'error'
            }"></i>
            <span class="type-text">{{ n.type | uppercase }}</span>
          </span>
        </td>
      </ng-container>

      <!-- Title Column -->
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef>TITLE</th>
        <td mat-cell *matCellDef="let n" class="bold-text">
          {{ n.title }}
        </td>
      </ng-container>
 
      <!-- Message Column -->
      <ng-container matColumnDef="message">
        <th mat-header-cell *matHeaderCellDef>MESSAGE</th>
        <td mat-cell *matCellDef="let n">
          {{ n.message }}
        </td>
      </ng-container>

      <!-- Date Column -->
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef>DATE</th>
        <td mat-cell *matCellDef="let n">
          {{ n.createdAt?.toDate() | date: 'medium' }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="handleNotificationClick(row)" class="clickable-row"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell text-center p-4" [attr.colspan]="displayedColumns.length">
          No notifications found.
        </td>
      </tr>
    </table>
  </div>

  <mat-paginator
    [length]="totalItems"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    [pageIndex]="pageIndex"
    (page)="handlePageEvent($event)"
    showFirstLastButtons
    aria-label="Select page of notifications">
  </mat-paginator>
</div>
